"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PlayerDetails_module_css_1 = __importDefault(require("./PlayerDetails.module.css"));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var PlayerDetailsLocationTab = function (player) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.title },
        react_1.default.createElement("span", null, t("TODO"))));
};
exports.default = PlayerDetailsLocationTab;
